import React, { useEffect, useState} from 'react';
import { useSelector, useDispatch} from 'react-redux'
import { closePopup } from '../../../actions/popup';
import classnames from 'classnames';
import querystring from 'querystring';
import { receiveItems } from '../../../actions/comment/guestbookComment'
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {addPrefix} from "../../../utils/UriUtil";

export default function GuestBookCommentReplyPopup() {
  const isCommentReplyPopupOpened = useSelector(state => state.popup.isCommentReplyPopupOpened)
  const id = useSelector(state => state.popup.commentReplyPopupCommentIds)
  const dispatch = useDispatch()

  const [comment, setComment] = useState('')
  const [validated, setValidated] = useState(false)

  function handlePopupClose() {
    dispatch(closePopup())
  }
  function handleReceiveItems(items, totalCount) {
    dispatch(receiveItems(items, totalCount))
  }

  function clearComment() {
    setComment('')
  }

  function handleClosePopup(e) {
    clearComment()
    handlePopupClose()
  }

  function handleChange(e) {
    setComment(e.target.value)
  }

  function handleSaveComment(e) {
    fetch(addPrefix(`/manage/guestBookComment/${id}/reply.json`), {
      method: "post",
      credentials: "include",
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      body: querystring.stringify({
        comment: comment
      })
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        clearComment()
        handlePopupClose()
        reFetchItems()
      })
      .catch(e => {
        console.log(e)
      })
  }

  function reFetchItems() {
    fetch(addPrefix("/manage/guestBookComments.json") + location.search, {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleReceiveItems(data.items, data.totalCount)
      })
      .catch(e => {
        console.log(e)
      })
  }

  useEffect(() => {
    setValidated(!!comment)
  }, [comment])


  if (!isCommentReplyPopupOpened) {
    return null
  }

  return (
    <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: '-112px'}}>
      <div className="inner_blog_layer inner_blog_layer1">
        <form>
          <div className="cont_layer">
            <strong className="tit_popup">답글 쓰기</strong>
            <textarea className="tf_blog" onChange={handleChange} value={comment}/>
          </div>
          <div className="fld_btn">
            <button type="button" className="btn_cancel" onClick={handleClosePopup}>취소</button>
            <button type="button" className={classnames('btn_default', {btn_off : !validated})} disabled={!validated} onClick={handleSaveComment}>확인</button>
          </div>
        </form>
      </div>
    </div>
  )
}

